const progressUpdateAge = (profile, age) => {
  return {
    ...profile,
    age,
  }
}

export default progressUpdateAge



// WEBPACK FOOTER //
// ./src/utils/progressUpdateAge.js